import { useEffect, Fragment, useState, useRef } from 'react';
import HeaderSEO from '@/shared/_seo';
import LayoutDefault from '@/shared/_layoutDefault';
import styled from 'styled-components';
import Link from 'next/link';
import InfoApplications from '@/shared/_info';


const ContentCard = styled.div`
    width: 100%;  

    .card{
        display: flex;
        flex-direction: row;
        padding: 10px 0px;
        min-height: 65px;
        border-radius: 10px;
    }

    .card:hover{
        border-color: #2D9CDB;
    }

    .card ~ .card{
        margin-top: 16px;
    }

    .card:last-child{
        margin-bottom: 16px;
    }

    .card.active .item-header{
        color: #2D9CDB;
        font-size: 18px;
        padding-top: 17px;
    }

    .card.active .item-body{
        display: block;
        color: #414042;
        padding: 7px 0px 10px 0px;
        font-size: 14px;
    }

    .card.active .pi{
        color: #2D9CDB;
    }
`;

const CardBody = styled.div`
    width: calc(100% - 40px);
    padding: 0px 20px;
    min-height: 45px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-family: 'Roboto', sans-serif;

    .item-header{
        color: #414042;
        font-size: 14px;
        font-weight: 500;
    }

    .item-body{
        display: none;
    }
`;

const CardAction = styled.div`
    width: 40px;
    min-height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;

    button{
        background-color: transparent;
        border: unset;
        outline: unset;
    }

    button i {
        pointer-events: none;
    }

    button:focus{
        background-color: transparent;
        border: unset;
        outline: unset;
    }
`;

const exampleData = [
    {
        questionId: 1,
        question: 'What is Lorem Ipsum?',
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    }, {
        questionId: 2,
        question: 'Where does it come from?',
        answer: `Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.
        
        The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`,
    }, {
        questionId: 3,
        question: 'Why do we use it?',
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    },
    {
        questionId: 4,
        question: 'Where can I get some?',
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    },
    {
        questionId: 5,
        question: 'Where can I get some?',
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    }
]

const MyAccount = () => {

    const onExpandItem = (e, index) => {
        const _this = e.target;
        const _icon = _this.querySelector('i');
        const _card = document.querySelector(`.card-item-${index}`);


        // const _allIcon = document.querySelectorAll('.pi-minus');
        // for(let _item of _allIcon){
        //     _item.classList.remove('pi-minus');
        //     _item.classList.add('pi-plus');
        // }

        if(_icon.classList.contains('pi-plus')){
            _icon.classList.remove('pi-plus');
            _icon.classList.add('pi-minus');
            _card.classList.add('active');
        }else{
            // console.log(1)
            _icon.classList.add('pi-plus');
            _icon.classList.remove('pi-minus');
            _card.classList.remove('active');
        }
        // console.log(_this, index);
    }

    const renderListFAQs = () => {
        let html = [];
        exampleData.forEach((item, index) => {
            html.push(
                <div className={`card card-item card-item-${index}`} key={index} onClick={(e) => onExpandItem(e, index)}>
                    <CardBody style={{pointerEvents: `none`}}>
                        <div className='item-header'>
                            <span>{item.question}</span>
                        </div>
                        <div className='item-body'>
                            {item.answer}
                        </div>
                    </CardBody>
                    <CardAction style={{pointerEvents: `none`}}>
                        <button className='btn-action'>
                            <i className='pi pi-plus'></i>
                        </button>
                    </CardAction>
                </div>
            )
        });
        return html;
    }

    return (
        <Fragment>
            <HeaderSEO
                title="Câu hỏi thường gặp"
                description="Câu hỏi thường gặp"
                siteTitle="Câu hỏi thường gặp"
            />
            <LayoutDefault>
                <div className='container-fluid'>
                    <div className='row' style={{ paddingTop: 90 }}>
                        <div className='col-md-12 text-center'>
                            <h3>CÂU HỎI THƯỜNG GẶP</h3>
                        </div>
                    </div>
                </div>
                <div className='container' style={{ paddingTop: 31 }}>
                    <ContentCard>
                        {renderListFAQs()}
                    </ContentCard>
                </div>
                <div className='container' style={{paddingTop: 63, paddingBottom: 113}}>
                    <div className='row'>
                        <div className='col-12 text-center'>
                            <b style={{fontSize: 30}}>Vẫn còn những câu hỏi ?</b>
                        </div>
                    </div>
                    <div className='row' style={{paddingTop: 16}}>
                        <div className='col-12 text-center'>
                            <span style={{fontSize: 14}}>Nếu bạn không thể tìm thấy một câu trả lời cho câu hỏi của bạn trong câu hỏi thường gặp của chúng tôi. Bạn có thể <Link legacyBehavior href={'/contact'} passHref>
                            <a>liên hệ với chúng tôi</a></Link>
                            </span>
                            <br/>
                            <span style={{fontSize: 14}}>Chúng tôi sẽ liên hệ lại trong thời gian sớm nhất.</span>
                        </div>
                    </div>
                </div>
                <InfoApplications/>
            </LayoutDefault>
        </Fragment>
    );
}

export default MyAccount;